import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import './LinkList.scss';
import { getBoxInfo, slugify } from '../../utils';

export const LinkList = ({ className, links, title }) => {
  const classes = classNames('link-list', className);
  const flatLinks = [...links.map(({ links }) => links)];
  return (
    <div className={classes}>
      <h2>{title}</h2>
      {flatLinks.map((link, index) => {
        const { description, url, title } = getBoxInfo(link);
        return (
          <p key={`${slugify(title)}-${index}`}>
            <a className='link-title' href={url}>
              {title}
            </a>
            {description && `: ${description}`}
          </p>
        );
      })}
    </div>
  );
};

LinkList.defaultProps = {
  links: [],
  title: 'Frequently Used',
};

LinkList.propTypes = {
  links: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default LinkList;

export const fragBoxLinkList = graphql`
  fragment boxLinkList on DirectusData_rl_components {
    links_lists {
      links_list {
        links {
          links {
            page {
              title
              display_name
              slug
              page_description
              parent {
                slug
                parent {
                  slug
                }
              }
            }
            project {
              slug
              title
            }
            anchor
            description
            display_name
            external
          }
          link_sort
        }
        title
      }
    }
  }
`;
